import { render, staticRenderFns } from "./default-error-page.vue?vue&type=template&id=8f295af4&scoped=true"
import script from "./default-error-page.vue?vue&type=script&lang=js"
export * from "./default-error-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f295af4",
  null
  
)

export default component.exports